// extracted by mini-css-extract-plugin
export default {"container":"oq-z","ratingLayout":"pq-z","ratingLabel":"qq-z","nonInteractiveRatingLabel":"rq-z"};